<template>
    <div class="uploadeWdn">
        <div class="uploadeBox">
            <van-uploader accept=".mp4,.png, .jpg, .jpeg" :before-read="beforeRead" :after-read="afterRead">
                <div class="uploader appendixRight">
                    <img src="./uploadeBtn.png" alt="" />
                    <span>上传附件</span>
                </div>
            </van-uploader>
            <!-- 上传的附件 -->
            <div
                class="appendix appendixRight"
                v-for="(item, idx) in fileList"
                :key="idx"
                @click="changeAppendix(item)"
            >
                <img v-if="item.type == 1" class="image" :src="item.url" alt="" />
                <img v-if="item.type == 2" class="video" src="./video.png" alt="" />
                <a
                    v-else-if="item.type == 3"
                    :href="'http://www.xdocin.com/xdoc?_func=to&_format=html&_cache=1&_xdoc=' + item.url"
                    rel="nofollow"
                >
                    <img class="word" src="./word.png" alt="" />
                </a>
                <img v-else-if="item.type == 4" class="zip" src="./zip.png" alt="" />
                <img class="close" src="./close.png" @click.stop="clonseBtn(idx)" alt="" />
            </div>
        </div>
        <!-- 上传中 -->
        <van-overlay :show="uploadLoading">
            <div class="uploadWrapper" @click.stop>
                <van-loading size="28px" vertical>上传中...</van-loading>
            </div>
        </van-overlay>
        <!-- 查看弹出层 -->
        <van-overlay :show="overlay" @click="changeOverlay">
            <div class="wrapper">
                <div class="block">
                    <img v-if="current.type == 1" :src="current.url" alt="" />
                    <video @click.stop ref="video" autoplay v-else-if="current.type == 2" controls :src="current.url" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    props: {
        uriList: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fileList: [],
            uploadLoading: false,
            overlay: false,
            current: {} // 当前点击的
        }
    },
    mounted() {
        console.log(this.uriList, 'uriListuriList')
        if (this.uriList.length > 0) {
            this.fileList = this.uriList
        }
    },
    methods: {
        clonseBtn(idx) {
            this.fileList.splice(idx, 1)
            this.$emit('enclosureData', this.fileList)
        },
        beforeRead(file) {
            if (this.fileList.length >= 10) {
                this.$notify({ type: 'warning', message: '最多上传10个文件' })
                return
            }
            if (file.size / 1024 / 1024 > 500) {
                this.$notify({ type: 'warning', message: '文件大小不超过500M' })
                return
            }
            this.uploadLoading = true
            return true
        },
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            let formData = new FormData()
            formData.append('file', file.file)
            this.$api.user
                .upload(formData)
                .then(async res => {
                    if (res.code == 0) {
                        const type = file.file.type
                        const size = file.file.size
                        const name = file.file.name
                        // type // 1图片 2音视频 3文档 4压缩包
                        let param = { type: 1, url: res.data, size, name }
                        if (type.includes('image')) {
                            param.type = 1
                            this.fileList.push(param)
                        } else if (type.includes('video')) {
                            param.type = 2
                            this.fileList.push(param)
                        }
                        console.log(this.fileList, 'this.fileList')
                        this.$emit('enclosureData', this.fileList)
                    }
                })
                .finally(() => {
                    this.uploadLoading = false
                })
        },
        changeOverlay() {
            if (this.current.type == 2) {
                this.$refs.video.pause()
            }
            this.overlay = false
        },
        changeAppendix(item) {
            console.log(item, 'changeAppendix')
            // 1图片 2音视频 3文档 4压缩包
            if (item.type == 4) return
            if (item.type == 3) {
                sessionStorage.setItem('previewArea', true)
            } else {
                this.overlay = true
                this.current = item
            }
        }
    }
}
</script>

<style lang="less" scoped>
.uploadeWdn {
    margin-top: 24px;
    .uploadeBox {
        flex-wrap: wrap;
        display: flex;
        .uploader {
            width: 155px;
            height: 155px;
            box-sizing: border-box;
            background: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #d6d6d6;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
                width: 36px;
                height: 36px;
                margin-bottom: 12px;
            }
            span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
            }
        }

        .appendix {
            margin-bottom: 24px;
            display: flex;
            width: 5%;
            // flex: 1;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 155px;
            height: 155px;
            background: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #eaeaea;
            .image,
            .zip,
            .video,
            .word {
                border-radius: 8px;
                width: 100%;
                height: 100%;
            }
            .close {
                position: absolute;
                top: -5%;
                right: -5%;
                width: 36px;
                height: 36px;
            }
        }
        .appendixRight {
            margin-right: 14px;
            &:nth-child(4) {
                margin-right: 0;
            }
        }
    }
    .uploadWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .block {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 100%;
            }
            video {
                width: 70%;
            }
        }
    }
}
</style>
